// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"b623a804","222":"63e45661","526":"29f39949","962":"a254b08e"}[chunkId] + ".chunk.css";
};